import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'on-demand-request-progress',
  templateUrl: './on-demand-request-progress.component.html',
  styleUrls: ['./on-demand-request-progress.component.scss']
})
export class OnDemandRequestProgressComponent implements OnInit {

  @Input("label") label: string;
  @Input("percentValue") percentValue: number;
  constructor() { }

  ngOnInit(): void {
  }
 
}
